import { makeCRUDSlice } from '@redux/crudCreator';
import { MODEL_NAME, rolePermissionGroupsActions } from './actions';

const slice = makeCRUDSlice(MODEL_NAME, rolePermissionGroupsActions);

export default slice.reducer;
